'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (object, date) {
  if (!date || date === 'Invalid Date' || !object) return '';
  return object.getHours() === 0 ? date.replace('12:', '00:') : date;
};